const PREFERRED_NAME_FIELDS = [
  'name',
  'location',
  'title',
  'label',
  'displayname',
  'display_name',
  'sitename',
  'site_name',
  'facility',
  'facility_name',
  'description',
];

/**
 * Prefer FeatureLayer.displayField, then common name attributes, then Feature
 * {OBJECTID}.
 */
export function getExternalFeatureTitle(
  attributes: Record<string, unknown> | null | undefined,
  displayField?: string | null
): string {
  if (!attributes) return 'Feature';

  if (displayField) {
    const direct = attributes[displayField];
    if (direct != null && String(direct).trim() !== '') {
      return String(direct);
    }
    const ciKey = Object.keys(attributes).find(
      (k) => k.toLowerCase() === displayField.toLowerCase()
    );
    if (ciKey) {
      const v = attributes[ciKey];
      if (v != null && String(v).trim() !== '') return String(v);
    }
  }

  const keys = Object.keys(attributes);
  for (const preferred of PREFERRED_NAME_FIELDS) {
    const key = keys.find((k) => k.toLowerCase() === preferred);
    if (!key) continue;
    const v = attributes[key];
    if (v != null && String(v).trim() !== '') return String(v);
  }

  const oid =
    attributes.OBJECTID ??
    attributes.objectid ??
    attributes.FID ??
    attributes.fid;
  if (oid != null && String(oid).trim() !== '') {
    return `Feature ${oid}`;
  }

  return 'Feature';
}
